/**
 * Contact Picker API integration.
 * Supported: Chrome 80+ on Android.
 * Not supported: Safari/iOS, Firefox, desktop browsers.
 * Falls back gracefully — always check isContactPickerSupported() first.
 */

export function isContactPickerSupported(): boolean {
  return 'contacts' in navigator && 'ContactsManager' in window;
}

export async function pickContact(): Promise<{ name?: string; phone?: string } | null> {
  if (!isContactPickerSupported()) return null;

  try {
    const props = ['tel', 'name'];
    const contacts = await (navigator as any).contacts.select(props, { multiple: false });

    if (!contacts || contacts.length === 0) return null;

    const contact = contacts[0];
    return {
      name: contact.name?.[0] || undefined,
      phone: contact.tel?.[0] || undefined,
    };
  } catch {
    // User cancelled or API error
    return null;
  }
}
